import { Builder } from './builder.js';
import { Component } from 'preact';
import { getMyUploads } from '../../lib/api.js';
import { getUploadPreviewURL } from '../../lib/images.js';
import { Upload } from '../../../common/data/designs.js';

export interface ArtworkBrowserProps {
	builder: Builder;
}

interface ArtworkBrowserState {
	ready?: boolean;
	vectors?: Upload[];
	rasters?: Upload[];
	digitizes?: Upload[];
	hover?: string;
}

export class ArtworkBrowser extends Component<ArtworkBrowserProps, ArtworkBrowserState> {

	render(props: ArtworkBrowserProps, state: ArtworkBrowserState) {
		
		if (!state.ready) return <h2>Loading...</h2>;
		
		return <div class="artwork-browser">
			
			{props.builder.manager.product.categories.includes('embroidery') && <>
				<h2>Digitized files</h2>
				{!!state.digitizes?.length && <div class="artwork-browser__grid">
					{state.digitizes.map(up => <div class="artwork-browser__artwork">
						<div
							class="artwork-browser__artwork-image"
							onMouseEnter={() => this.setState({ hover: up.id })}
							onMouseLeave={() => this.setState({ hover: undefined })}
						>
							<img src={state.hover == up.id && up.vector_upload_data ? getUploadPreviewURL(up.vector_upload_data) : getUploadPreviewURL(up)} />
						</div>
						<div class="artwork-browser__artwork-actions">
							<button onClick={() => {
								const part = props.builder.manager.addUpload(up);
								props.builder.closeDialog();
								props.builder.selectPart(part.id);
							}}>choose</button>
						</div>
					</div>)}
				</div>}
				{!state.digitizes?.length && <p>You have no uploaded digitized images.</p>}
			</>}
			
			<h2>Vector files</h2>
			{!!state.vectors?.length && <div class="artwork-browser__grid">
				{state.vectors.map(up => <div class="artwork-browser__artwork">
					<div class="artwork-browser__artwork-image">
						<img src={getUploadPreviewURL(up)} />
					</div>
					<div class="artwork-browser__artwork-actions">
						<button onClick={() => {
							const part = props.builder.manager.addUpload(up);
							props.builder.closeDialog();
							props.builder.selectPart(part.id);
						}}>choose</button>
					</div>
				</div>)}
			</div>}
			{!state.vectors?.length && <p>You have no uploaded vectors or vectorized logos.</p>}

			<h2>Raster files</h2>
			{!!state.rasters?.length && <div class="artwork-browser__grid">
				{state.rasters.map(up => <div class="artwork-browser__artwork">
					<div
						class="artwork-browser__artwork-image"
						onMouseEnter={() => this.setState({ hover: up.id })}
						onMouseLeave={() => this.setState({ hover: undefined })}
					>
						<img src={state.hover == up.id && up.vector_upload_data ? getUploadPreviewURL(up.vector_upload_data) : getUploadPreviewURL(up)} />
					</div>
					<div class="artwork-browser__artwork-actions">
						<button onClick={() => {
							const part = props.builder.manager.addUpload(up);
							props.builder.closeDialog();
							props.builder.selectPart(part.id);
						}}>choose</button>
					</div>
				</div>)}
			</div>}
			{!state.rasters?.length && <p>You have no uploaded raster images.</p>}
			
			{!props.builder.manager.product.categories.includes('embroidery') && <>
				<h2>Digitized files</h2>
				{!!state.digitizes?.length && <div class="artwork-browser__grid">
					{state.digitizes.map(up => <div class="artwork-browser__artwork">
						<div
							class="artwork-browser__artwork-image"
							onMouseEnter={() => this.setState({ hover: up.id })}
							onMouseLeave={() => this.setState({ hover: undefined })}
						>
							<img src={state.hover == up.id && up.vector_upload_data ? getUploadPreviewURL(up.vector_upload_data) : getUploadPreviewURL(up)} />
						</div>
						<div class="artwork-browser__artwork-actions">
							<button onClick={() => {
								const part = props.builder.manager.addUpload(up);
								props.builder.closeDialog();
								props.builder.selectPart(part.id);
							}}>choose</button>
						</div>
					</div>)}
				</div>}
				{!state.digitizes?.length && <p>You have no uploaded digitized images.</p>}
			</>}
		</div>;
		
		
	}
	
	componentDidMount() {
		this.init();
	}

	async init() {
		const [vectors, rasters, digitizes] = (await Promise.all([
			getMyUploads({ filter: 'vectors' }),
			getMyUploads({ filter: 'rasters' }),
			getMyUploads({ filter: 'digitize' }),
		])).map(res => res.uploads);
		this.setState({
			ready: true,
			vectors,
			rasters,
			digitizes,
		});
	}
	
}
